import React from 'react'
import { BreachEvent } from '@news-mono/web-common'
import { MessageBanner } from '../../../../../banners/MessageBanner/MessageBanner'
import { SimpleTextBanner } from '../../../../../banners/SimpleTextBanner/SimpleTextBanner'
import { TextLink } from '../../../../../typography/TextLink/TextLink'
import { packageOfferDetails } from '../../../common'
import { VideoTrailerCard } from '../../../../../cards/VideoTrailerCard/VideoTrailerCard'
import {
    StyledMessage,
    StyledTitle,
    StyledLiveTrailerWrap,
    StyledPrintDigMessage,
    StyledPrintDigTitle,
    StyledTerms,
} from './BreachWallContent/BreachWallContent.styled'
import { BreachWallContentType } from '../BreachNotificationWrapper'
import BreachWallContent from './BreachWallContent/BreachWallContent'

export interface BreachNotificationProps {
    breachCreativeName: string
    breachDeal: string
    articleId: string | undefined
    onEvent: (event: BreachEvent) => void
    type: BreachWallContentType
    // Optional properties that can be passed on a per-campaign basis
    contentOptions?: {
        [key: string]: any
    }
}

export function BreachNotification({
    articleId,
    breachDeal,
    breachCreativeName,
    onEvent,
    contentOptions,
    type,
}: BreachNotificationProps) {
    const shouldShowLiveSportsTrailer =
        contentOptions && contentOptions['showLiveSportTrailer']

    const is50percentOffDeal =
        breachDeal === 'COVIDDIG' || breachDeal === 'GOVAN50'

    const isPrintDigCampaign = breachDeal === 'BRE1DISC'

    const subscriptionPackages = packageOfferDetails(
        type,
        breachCreativeName,
        breachDeal,
        onEvent,
        articleId,
    )

    return (
        <div data-testid="BreachScreen">
            <MessageBanner
                icon="subscriber"
                connector="solid-arrow"
                onEvent={onEvent}
            >
                <p>
                    This article is available to subscribers who have digital
                    access included in their subscription.
                </p>
            </MessageBanner>

            <BreachWallContent
                articleId={articleId}
                breachCreativeName={breachCreativeName}
                breachDeal={breachDeal}
                onEvent={onEvent}
                title={() => {
                    if (is50percentOffDeal) {
                        return (
                            <React.Fragment>
                                <StyledTitle>Limited Offer</StyledTitle>
                                <StyledMessage>
                                    <p>Save over 50% for 8 weeks*</p>
                                </StyledMessage>
                            </React.Fragment>
                        )
                    }

                    if (isPrintDigCampaign) {
                        return (
                            <React.Fragment>
                                <StyledPrintDigTitle>
                                    News delivered to your home.
                                    <br />
                                    And your pocket.
                                    <br />
                                    For just $1.*
                                </StyledPrintDigTitle>
                                <StyledPrintDigMessage>
                                    <p>Save over 50% for 8 weeks*</p>
                                </StyledPrintDigMessage>
                            </React.Fragment>
                        )
                    }

                    return (
                        <React.Fragment>
                            <StyledTitle>Subscribe today.</StyledTitle>
                            <StyledMessage>
                                <p>
                                    Get unlimited access to award-winning
                                    journalism from Western Australia's biggest
                                    newsroom with your subscription.
                                </p>
                            </StyledMessage>
                        </React.Fragment>
                    )
                }}
                terms={() => {
                    if (isPrintDigCampaign) {
                        return (
                            <React.Fragment>
                                <StyledTerms>Cancel anytime.</StyledTerms>
                                <StyledTerms>
                                    *Valid for new subscribers only.
                                    {` ${breachDealTerms(breachDeal)}`}
                                    <br />
                                    T&Cs apply
                                </StyledTerms>
                            </React.Fragment>
                        )
                    }

                    if (is50percentOffDeal) {
                        return (
                            <StyledTerms>
                                *Valid for new subscribers only.
                                {` ${breachDealTerms(breachDeal)}`}
                                <br />
                                T&Cs apply
                            </StyledTerms>
                        )
                    }

                    return null
                }}
                mediaBanner={() => {
                    if (shouldShowLiveSportsTrailer) {
                        return (
                            <StyledLiveTrailerWrap>
                                <VideoTrailerCard
                                    layoutMode="double"
                                    onEvent={() => null}
                                />
                            </StyledLiveTrailerWrap>
                        )
                    }
                    return null
                }}
                subscriptionPackages={subscriptionPackages}
            />

            <SimpleTextBanner>
                <p>
                    All subscriptions include exclusive subscriber offers,
                    events and giveaways with West Rewards, our subscriber
                    rewards program.
                </p>
                <p>
                    Need Help?{' '}
                    <TextLink href="tel:1800 811 855">1800 811 855</TextLink>.
                </p>
            </SimpleTextBanner>
        </div>
    )
}

function breachDealTerms(deal: string) {
    switch (deal) {
        case 'GOVAN50':
            return 'Offer ends 20 February 2021.'
        case 'BRE1DISC':
            return 'Offer ends 2 May 2021.'
        default:
            return ''
    }
}
